import React from "react";
import PropTypes from "prop-types";
import Markdown from "../../components/Markdown";

const RejectReasons = ({ reasons }) => {
  return (
    <div className="teaser__reject-reasons">
      <span className="teaser__reject-reasons-item">Запрещено:</span>
      {reasons.map(reason => {
        return (
          <span className="teaser__reject-reasons-item" key={reason.id}>
            <Markdown text={reason.message} />
          </span>
        );
      })}
    </div>
  );
};

RejectReasons.propTypes = {
  reasons: PropTypes.array.isRequired
};

RejectReasons.defaultProps = {
  reasons: []
};

export default RejectReasons;
